<template>
    <hts-drawer
        v-model="visible"
        :custom="['header', 'footer']"
        :title="$t('labels.editDocument')"
        :submit="visibleDocument"
        :undo-enable="true"
        :rules="rules.editDocumentVehicle"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-select
                    v-model="dataFormEditDocument.type"
                    :label="$t('labels.documentType')"
                    required
                    :items="listTypeDocument"
                    key-id="key"
                    key-label="value"
                    :color="props.color"
                    name="documentType"
                    prop="documentType" />
                <hts-form-input
                    v-model="dataFormEditDocument.fileName"
                    :label="$t('labels.documentFileName')"
                    :color="props.color"
                    name="documentFileName"
                    prop="documentFileName" />

                <hts-form-input
                    v-if="dataFormEditDocument.type === listTypeDocument[0].key"
                    v-model="dataFormEditDocument.insurancePrice"
                    :label="$t('labels.insurancePrice')"
                    :color="props.color"
                    required
                    type="number"
                    name="insurancePrice"
                    prop="insurancePrice" />
                <hts-form-date
                    v-if="dataFormEditDocument.type === listTypeDocument[0].key"
                    v-model="dataFormEditDocument.expiredDate"
                    :label="$t('labels.expiredDate')"
                    :color="color"
                    required
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-file
                    ref="file"
                    v-model="fileDocument"
                    type="file"
                    :label="$t('labels.document')"
                    name="document"
                    prop="document"
                    :file-name="dataFormEditDocument.fileOriginName" />
                <hts-form-date
                    v-if="dataFormEditDocument.type === listTypeDocument[1].key"
                    v-model="dataFormEditDocument.expiredDate"
                    required
                    :label="$t('labels.expiredDate')"
                    :color="color"
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-input
                    v-model="dataFormEditDocument.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description" />
            </div>
        </hts-card>

        <hts-modal
            :show="showConfirmAddDocument"
            :title="$t('labels.confirmEditDocument')"
            type="confirm"
            :content="$t('labels.contentConfirmExpiredDateDocument')"
            @hide="showConfirmAddDocument = false"
            @confirm="handleSubmitFormEditDocument" />
    </hts-drawer>
</template>

<script lang="ts" setup>
import form from '../imports/form'
const { rules } = form

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  },
  documentInfo: {
    type: Object
  },
  type: {
    type: String,
    default: ''
  }
})

const _initForm = {
  document: '',
  fileName: '',
  type: '',
  privacy: '',
  description: '',
  expiredDate: null,
  insurancePrice: null,
  fileOriginName: ''
}
const dataFormEditDocument = reactive<{ [key: string]: any }>({ ..._initForm })
const emits = defineEmits(['close', 'refreshDataTables'])
const visible = ref(false)
const creating = ref(false)
const fileDocument = ref<File | string>('')

const openEditDocument = () => {
  visible.value = true
}
defineExpose({
  openEditDocument
})
const closeOverSide = () => {
  visible.value = false
}
const showConfirmAddDocument = ref(false)

function _formatDate (date: any) {
  if (!date) {
    return ''
  }
  const d = new Date(date)
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  const year = d.getFullYear()

  if (month.length < 2) {
    month = '0' + month
  }
  if (day.length < 2) {
    day = '0' + day
  }

  return [year, month, day].join('-')
}
watch(props, () => {
  dataFormEditDocument.fileOriginName = ''
  Object.assign(dataFormEditDocument, {
    ...props.documentInfo,
    expiredDate: _formatDate(props.documentInfo?.expiredDate),
    expiredDateRegistry: _formatDate(props.documentInfo?.expiredDateRegistry)
  })
  fileDocument.value = ''
})
const undo = () => {
  fileDocument.value = ''
  Object.assign(dataFormEditDocument, { ...props.documentInfo })
}
const listTypeDocument = [
  {
    key: 'INSURANCE',
    value: $t('labels.insurance')
  },
  {
    key: 'REGISTRY',
    value: $t('labels.registry')
  },
  {
    key: 'OTHER',
    value: $t('labels.other')
  }
]

const handleSubmitFormEditDocument = async () => {
  const api = {
    method: 'PUT',
    url: '/vehicle/remooc-document/file/ID'
  }

  const dataForm = new FormData()
  dataForm.append('document', fileDocument.value)
  dataForm.append('remooc', dataFormEditDocument.remooc || '')
  dataForm.append('fileName', dataFormEditDocument.fileName || '')
  dataForm.append('type', dataFormEditDocument.type || '')
  dataForm.append('description', dataFormEditDocument.description || '')
  dataForm.append('expiredDate', dataFormEditDocument.expiredDate || '')

  dataForm.append('insurancePrice', JSON.stringify(dataFormEditDocument.insurancePrice))
  const data: any = await $api(api, { uriParams: { ID: props.documentInfo?._id }, body: dataForm })

  const resData: any = data?.data?.value
  if (resData.success) {
    process.client && $toast().success($t('notifications.editSuccessDocument'))
    emits('close')
    emits('refreshDataTables')
    visible.value = false
    showConfirmAddDocument.value = false
  }
}

const visibleDocument = async () => {
  if (
    dataFormEditDocument.expiredDate &&
    ['INSURANCE', 'REGISTRY'].includes(dataFormEditDocument.type) &&
    new Date(dataFormEditDocument.expiredDate + ' 23:59:59').getTime() < new Date().getTime()
  ) {
    showConfirmAddDocument.value = true
  } else {
    await handleSubmitFormEditDocument()
  }
}
</script>
